/**
 * 🧘 FRASES FRUGALES - Cortina del Dashboard
 * 50+ frases célebres sobre frugalidad, ahorro y vida simple
 */

export const FRUGAL_QUOTES = [
  // Frugalidad y simplicidad
  { text: "La frugalidad no es privación, es abundancia consciente.", author: "ZenSaver" },
  { text: "Ser frugal es elegir lo que realmente importa.", author: "ZenSaver" },
  { text: "La simplicidad es la máxima sofisticación.", author: "Leonardo da Vinci" },
  { text: "La riqueza no es tener mucho, sino necesitar poco.", author: "Epicteto" },
  { text: "Vive simplemente para que otros puedan simplemente vivir.", author: "Mahatma Gandhi" },
  
  // Ahorro y finanzas
  { text: "No ahorres lo que te queda después de gastar, gasta lo que te queda después de ahorrar.", author: "Warren Buffett" },
  { text: "El ahorro de hoy es la libertad de mañana.", author: "ZenSaver" },
  { text: "Un centavo ahorrado es un centavo ganado.", author: "Benjamin Franklin" },
  { text: "La mejor inversión es en ti mismo.", author: "Warren Buffett" },
  { text: "El dinero es un buen sirviente pero un mal amo.", author: "Francis Bacon" },
  
  // Sabiduría financiera
  { text: "Gasta menos de lo que ganas, invierte la diferencia.", author: "Paul Clitheroe" },
  { text: "No es tu salario lo que te hace rico, es tu hábito de ahorro.", author: "Charles A. Jaffe" },
  { text: "La paz financiera no se trata de tener mucho, sino de deber poco.", author: "Dave Ramsey" },
  { text: "El presupuesto no limita tu libertad, te la da.", author: "ZenSaver" },
  { text: "Cuida de los centavos y los pesos se cuidarán solos.", author: "Proverbio" },
  
  // Vida consciente
  { text: "Compra solo lo necesario, no lo conveniente.", author: "Proverbio japonés" },
  { text: "La felicidad no está en las cosas, está en las experiencias.", author: "ZenSaver" },
  { text: "Menos es más.", author: "Ludwig Mies van der Rohe" },
  { text: "La verdadera riqueza es la salud, no piezas de oro y plata.", author: "Mahatma Gandhi" },
  { text: "El que compra lo que no necesita, roba a sí mismo.", author: "Proverbio sueco" },
  
  // Libertad financiera
  { text: "La independencia financiera es la capacidad de vivir de los ingresos de tus recursos.", author: "Jim Rohn" },
  { text: "Tu libertad está en tu billetera.", author: "ZenSaver" },
  { text: "El dinero no compra la felicidad, pero la pobreza tampoco.", author: "ZenSaver" },
  { text: "Trabaja para vivir, no vivas para trabajar.", author: "Proverbio" },
  { text: "La deuda es la esclavitud del hombre libre.", author: "Publilius Syrus" },
  
  // Paciencia y constancia
  { text: "La paciencia es la madre de todas las virtudes financieras.", author: "ZenSaver" },
  { text: "Gota a gota se llena el vaso.", author: "Proverbio" },
  { text: "El interés compuesto es la octava maravilla del mundo.", author: "Albert Einstein" },
  { text: "Roma no se construyó en un día, ni tu patrimonio tampoco.", author: "ZenSaver" },
  { text: "La constancia vence lo que la dicha no alcanza.", author: "Proverbio español" },
  
  // Mindfulness financiero
  { text: "Antes de comprar, pregúntate: ¿Lo necesito o lo deseo?", author: "ZenSaver" },
  { text: "El dinero habla, pero la sabiduría escucha.", author: "ZenSaver" },
  { text: "Conoce el precio de todo y el valor de nada es la definición de un cínico.", author: "Oscar Wilde" },
  { text: "La gratitud convierte lo que tenemos en suficiente.", author: "Melody Beattie" },
  { text: "El contentamiento es la piedra filosofal que convierte todo en oro.", author: "Benjamin Franklin" },
  
  // Planificación
  { text: "Un objetivo sin un plan es solo un deseo.", author: "Antoine de Saint-Exupéry" },
  { text: "Planifica tu gasto o tu gasto planificará tu vida.", author: "ZenSaver" },
  { text: "El mejor momento para plantar un árbol fue hace 20 años. El segundo mejor momento es ahora.", author: "Proverbio chino" },
  { text: "No planificar es planificar el fracaso.", author: "Alan Lakein" },
  { text: "El futuro pertenece a quienes se preparan para él.", author: "Malcolm X" },
  
  // Equilibrio
  { text: "El equilibrio no es algo que encuentras, es algo que creas.", author: "Jana Kingsford" },
  { text: "Ni muy muy, ni tan tan.", author: "Proverbio latino" },
  { text: "Todo con moderación, incluyendo la moderación.", author: "Oscar Wilde" },
  { text: "La virtud está en el medio.", author: "Aristóteles" },
  { text: "Gasta en lo que amas, ahorra en lo que no.", author: "ZenSaver" },
  
  // Mentalidad
  { text: "Cambia tu mentalidad y cambiarás tu vida.", author: "ZenSaver" },
  { text: "No es lo que ganas, es lo que conservas.", author: "Robert Kiyosaki" },
  { text: "La mente es todo. En lo que piensas, te conviertes.", author: "Buda" },
  { text: "Los ricos invierten en tiempo, los pobres invierten en dinero.", author: "Warren Buffett" },
  { text: "Tu actitud, no tu aptitud, determinará tu altitud.", author: "Zig Ziglar" },
  
  // Zen y tranquilidad
  { text: "La paz interior comienza cuando dejas de preocuparte por lo material.", author: "ZenSaver" },
  { text: "El zen de las finanzas es gastar conscientemente.", author: "ZenSaver" },
  { text: "Cuando controlas tu dinero, tu dinero no te controla.", author: "ZenSaver" },
  { text: "La serenidad financiera es el verdadero lujo.", author: "ZenSaver" },
  { text: "Tu ZEN diario es tu paz diaria.", author: "ZenSaver" }
];

// Función para obtener una frase aleatoria
export const getRandomQuote = () => {
  const index = Math.floor(Math.random() * FRUGAL_QUOTES.length);
  return FRUGAL_QUOTES[index];
};

// Función para obtener múltiples frases únicas
export const getRandomQuotes = (count = 5) => {
  const shuffled = [...FRUGAL_QUOTES].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, count);
};

export default FRUGAL_QUOTES;
